import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useCallback, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { getClient } from '@chegg/rio-sdk-web';
import prepareEventData from './utils/prepareEventData';
import useTrackingData from './utils/useTrackingData';
import useOnVisibilityChange from './utils/useOnVisibilityChange';
import useIsMounted from './utils/useIsMounted';

// TimeOnPage is design to fire a log to capture how
// long the user was on the page.
// To handle unload events, we need to be able to
// handle route changes and page unloads.
export var useOnUnloadTimeOnPage = function useOnUnloadTimeOnPage(params) {
  var isMounted = useIsMounted();
  var client = getClient();
  var router = useRouter();
  var start = useRef(Date.now());
  var timeSpend = useRef(0);
  useEffect(function () {
    start.current = Date.now();
  }, []);

  //Identifying tracking type from url parameters and merging with other parameters
  var trackingData = useTrackingData(params);
  // Resets unload on receiving updated event data
  useEffect(function () {
    /* istanbul ignore else */
    if (isMounted) {
      start.current = Date.now();
      timeSpend.current = 0;
    }
  }, [trackingData]);

  // Callback responsible for sending unload events to rio
  var trackUnload = useCallback(function () {
    var now = Date.now();
    timeSpend.current += now - start.current;
    start.current = now;
    if (trackingData) {
      client.sendEvent(prepareEventData(_objectSpread(_objectSpread({}, trackingData), {}, {
        interval_type: 'unload',
        interval: Math.round(timeSpend.current / 1000)
      }), true));
    }
  }, [trackingData]);

  // Callback responsible handling use cases when user comes back to a tab that was previously hidden
  var onVisible = useCallback(function () {
    start.current = Date.now();
  }, []);

  // Callback responsible handling use cases when user hides tab
  var onHidden = useCallback(function () {
    trackUnload();
  }, [trackUnload]);
  useOnVisibilityChange({
    onVisible: onVisible,
    onHidden: onHidden
  });
  useEffect(function () {
    var onRouteChange = function onRouteChange() {
      trackUnload();
    };
    var onUnload = function onUnload(e) {
      trackUnload();
      delete e.returnValue;
      return undefined;
    };

    // We don't want to block the unload or show a dialog popup
    // So we need to avoid preventDefault() and be mindful of the
    // return type.
    window.addEventListener('beforeunload', onUnload);
    router.events.on('routeChangeStart', onRouteChange);
    return function () {
      window.removeEventListener('beforeunload', onUnload);
      router.events.off('routeChangeStart', onRouteChange);
    };
  }, [trackUnload, router]);
};
export default useOnUnloadTimeOnPage;